const basePath = "network/";

export const network = {
  id: 3,
  category: "Networking",

  filters: {
    Brand: { type: "checkbox" },
    Ports: { type: "checkbox" },
    Uplink: { type: "checkbox" },
    Features: { type: "checkbox" },
    Model: { type: "checkbox" },
    Speed: { type: "checkbox" },
    RAM: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "Cisco Catalyst 2960X Switch",
      bestSeller: true,
      image: `${basePath}Catalyst_2960X-24TS-L.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 2960X-24TS-L",
        Ports: "24 x Gigabit Ethernet",
        Uplink: "4 x SFP",
        "Switching Capacity": "216 Gbps",
      },
      about: `
        <ul>
          <li>Layer 2 switch for secure business connectivity.</li>
          <li>Energy-efficient and scalable network foundation.</li>
        </ul>
      `,
    },
    {
      name: "Ubiquiti UniFi U6 Pro Access Point",
      bestSeller: true,
      image: `${basePath}UniFi_U6-Pro.png`,
      details: {
        Brand: "Ubiquiti",
        Model: "UniFi U6-Pro",
        WiFi: "Wi-Fi 6 (802.11ax)",
        Speed: "Up to 5.3 Gbps",
      },
      about: `
        <ul>
          <li>High-performance AP for dense client environments.</li>
          <li>Supports PoE+ and UniFi Controller integration.</li>
        </ul>
      `,
    },
    {
      name: "MikroTik CCR1009 Router",
      bestSeller: true,
      image: `${basePath}CCR1009-7G-1C-1S+.png`,
      details: {
        Brand: "MikroTik",
        Model: "CCR1009-7G-1C-1S+",
        CPU: "Tilera 9-core 1.2 GHz",
        RAM: "2 GB",
      },
      about: `
        <ul>
          <li>Carrier-grade router for ISPs and enterprises.</li>
          <li>Supports hardware-accelerated IPsec encryption.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 9200 Series",
      bestSeller: true,
      image: `${basePath}Catalyst_9200.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 9200",
        Ports: "24/48 x 1G",
        Uplink: "1/2.5/10G uplink options",
        Features: "Layer 2/3, PoE/PoE+",
      },
      about: `
        <ul>
          <li>Modern access-layer switch for enterprise campus deployments.</li>
          <li>Built-in security, automation and SD-Access compatible.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 9300 Series",
      bestSeller: true,
      image: `${basePath}Catalyst_9300.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 9300",
        Ports: "24/48 x 1G with 10G uplinks",
        Uplink: "10G/25G uplink modules",
        Features: "Stackable (StackWise), SD-Access, PoE++",
      },
      about: `
        <ul>
          <li>Industry-leading stackable access switch designed for security and programmability.</li>
          <li>Supports advanced telemetry, segmentation and automation.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 9400 Series",
      bestSeller: false,
      image: `${basePath}Catalyst_9400.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 9400",
        Type: "Modular Chassis",
        Slots: "Up to 8 line-card slots",
        Features: "Modular aggregation, advanced routing",
      },
      about: `
        <ul>
          <li>Modular enterprise campus access/distribution switch chassis.</li>
          <li>Designed for high availability, large scale deployments and virtualization.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 9500 Series",
      bestSeller: false,
      image: `${basePath}Catalyst_9500.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 9500",
        Ports: "24/48 x 10G/25G/40G/100G",
        Role: "Core/Aggregation",
        Features: "Segment routing, advanced telemetry",
      },
      about: `
        <ul>
          <li>Fixed core/aggregation switch for enterprise campus and branch cores.</li>
          <li>High-performance platform with advanced routing and security capabilities.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Nexus 9000 Series",
      bestSeller: false,
      image: `${basePath}Nexus_9000.png`,
      details: {
        Brand: "Cisco",
        Model: "Nexus 9000",
        Ports: "10/25/40/50/100G options",
        Modes: "NX-OS or ACI",
        Role: "Data Center Leaf/Spine",
      },
      about: `
        <ul>
          <li>Data center switching platform engineered for low-latency high-throughput fabrics.</li>
          <li>Supports ACI for policy-driven automation or NX-OS for traditional operations.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 2960-L Series",
      bestSeller: false,
      image: `${basePath}Catalyst_2960-L.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 2960-L",
        Ports: "8/24/48 x 1G",
        Uplink: "1G SFP",
        Features: "Layer 2, fanless options",
      },
      about: `
        <ul>
          <li>Cost-effective, compact access switches for small branches and retail.</li>
          <li>Offers reliable basic switching with PoE options.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 9600 Series",
      bestSeller: false,
      image: `${basePath}Catalyst_9600.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 9600",
        Type: "Modular Core",
        Role: "Core/Aggregation",
        Features: "High-density 10/25/40/100G, advanced routing",
      },
      about: `
        <ul>
          <li>Modular core switch built for large campus and enterprise cores.</li>
          <li>Provides high availability, scale and programmability for modern networks.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 9200CX Series",
      bestSeller: false,
      image: `${basePath}Catalyst_9200CX.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 9200CX",
        Ports: "Compact 1G/mGig",
        Role: "Space-constrained access",
        Features: "Small form factor, security features",
      },
      about: `
        <ul>
          <li>Compact member of the 9200 family for small closets and tight spaces.</li>
          <li>Delivers enterprise features in a compact footprint.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 1300 Series",
      bestSeller: false,
      image: `${basePath}Catalyst_1300.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 1300",
        Ports: "8/16/24 x 1G",
        Role: "SMB Managed Access",
        Features: "Layer 2, basic Layer 3, PoE options",
      },
      about: `
        <ul>
          <li>Managed switches tailored to small and medium businesses.</li>
          <li>Provides essential security and reliability features at lower cost.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 1200 Series",
      bestSeller: false,
      image: `${basePath}Catalyst_1200.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 1200",
        Ports: "8/16 x 1G",
        Role: "Smart Managed for SMB",
        Features: "Simple management, energy-efficient",
      },
      about: `
        <ul>
          <li>Entry-level smart switches for small deployments and branch offices.</li>
          <li>Easy-to-use management with essential switching features.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst IE9300 Series (Industrial)",
      bestSeller: false,
      image: `${basePath}IE9300.png`,
      details: {
        Brand: "Cisco",
        Model: "IE9300",
        Type: "Industrial Ethernet",
        Ports: "1G/2.5G, fiber options",
        Features: "Ruggedized, DIN-rail, extended temp",
      },
      about: `
        <ul>
          <li>Rugged industrial switch family for harsh environments.</li>
          <li>Designed for extended temperature, vibration and reliability.</li>
        </ul>
      `,
    },
    {
      name: "Cisco IE3x00 Series (Industrial)",
      bestSeller: false,
      image: `${basePath}IE3x00.png`,
      details: {
        Brand: "Cisco",
        Model: "IE3x00",
        Type: "Industrial",
        Ports: "Varied gigabit/fiber options",
        Features: "DIN-rail, PoE, secure boot",
      },
      about: `
        <ul>
          <li>Family of industrial switches for manufacturing and field environments.</li>
          <li>Provides secure, resilient connectivity for OT networks.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Nexus 3000 Series",
      bestSeller: false,
      image: `${basePath}Nexus_3000.png`,
      details: {
        Brand: "Cisco",
        Model: "Nexus 3000",
        Role: "Data Center Top-of-Rack",
        Features: "Low-latency, high-density 10/25/40/100G",
      },
      about: `
        <ul>
          <li>Low-latency switches optimized for data center workloads and high-frequency trading.</li>
          <li>High-density ports with options for hardware acceleration.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Nexus 3550 Series",
      bestSeller: false,
      image: `${basePath}Nexus_3550.png`,
      details: {
        Brand: "Cisco",
        Model: "Nexus 3550",
        Role: "Low-latency Spine/Leaf",
        Features: "Ultra low-latency, FPGA-optimized options",
      },
      about: `
        <ul>
          <li>Ultra low-latency platform for specialized data center environments.</li>
          <li>Designed for environments where jitter and latency are critical.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Nexus 2000 Series (Fabric Extenders)",
      bestSeller: false,
      image: `${basePath}Nexus_2000.png`,
      details: {
        Brand: "Cisco",
        Model: "Nexus 2000",
        Type: "Fabric Extender",
        Role: "Extension of Nexus parent switch",
        Features: "Simplified management via parent Nexus",
      },
      about: `
        <ul>
          <li>Fabric extenders that simplify cabling and management in data centers.</li>
          <li>Require a parent Nexus switch for control plane functions.</li>
        </ul>
      `,
    },
    {
      name: "Cisco MDS 9000 Series (SAN)",
      bestSeller: false,
      image: `${basePath}MDS_9000.png`,
      details: {
        Brand: "Cisco",
        Model: "MDS 9000",
        Type: "Fibre Channel SAN Switch",
        Ports: "8/16/32 GFC options",
        Features: "SAN zoning, Fibre Channel services",
      },
      about: `
        <ul>
          <li>Purpose-built SAN switching family for storage networks.</li>
          <li>Provides advanced Fibre Channel services and scalability.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Meraki MS120 Series",
      bestSeller: false,
      image: `${basePath}MS120.png`,
      details: {
        Brand: "Cisco Meraki",
        Model: "MS120",
        Role: "Cloud-managed access",
        Ports: "8-48 x 1G",
        Features: "Cloud dashboard, simple provisioning",
      },
      about: `
        <ul>
          <li>Cloud-managed access switches providing simple centralized management.</li>
          <li>Ideal for distributed sites that need easy provisioning and monitoring.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Meraki MS130 Series",
      bestSeller: false,
      image: `${basePath}MS130.png`,
      details: {
        Brand: "Cisco Meraki",
        Model: "MS130",
        Role: "mGig-capable access",
        Features: "Multi-gig support, cloud-managed",
      },
      about: `
        <ul>
          <li>Multi-gig access switches for high-performance wireless and edge devices.</li>
          <li>Managed from the Meraki cloud dashboard.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Meraki MS225 Series",
      bestSeller: false,
      image: `${basePath}MS225.png`,
      details: {
        Brand: "Cisco Meraki",
        Model: "MS225",
        Role: "Cloud-managed aggregation",
        Features: "Stacking, cloud analytics",
      },
      about: `
        <ul>
          <li>Cloud-managed switches that balance performance with simple operations.</li>
          <li>Good fit for campus aggregation or larger branch sites.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Meraki MS355 Series",
      bestSeller: false,
      image: `${basePath}MS355.png`,
      details: {
        Brand: "Cisco Meraki",
        Model: "MS355",
        Role: "High-performance access/aggregation",
        Features: "Cloud management, high port density",
      },
      about: `
        <ul>
          <li>High-performance Meraki switches for demanding campus networks.</li>
          <li>Provides rich telemetry through the Meraki dashboard.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Meraki MS390 Series",
      bestSeller: false,
      image: `${basePath}MS390.png`,
      details: {
        Brand: "Cisco Meraki",
        Model: "MS390",
        Role: "Campus aggregation",
        Features: "High throughput, cloud-managed",
      },
      about: `
        <ul>
          <li>Designed for campus and aggregation layers with strong throughput and analytics.</li>
          <li>Integrates tightly with Cisco Meraki cloud features.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Meraki MS400 Series",
      bestSeller: false,
      image: `${basePath}MS450.png`,
      details: {
        Brand: "Cisco Meraki",
        Model: "MS400",
        Role: "Aggregation",
        Features: "High density uplinks, cloud-managed",
      },
      about: `
        <ul>
          <li>Aggregation switches with robust uplink capacity and cloud management.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Meraki MS450 Series",
      bestSeller: false,
      image: `${basePath}MS450.png`,
      details: {
        Brand: "Cisco Meraki",
        Model: "MS450",
        Role: "High-performance aggregation",
        Features: "40/100G uplinks, cloud telemetry",
      },
      about: `
        <ul>
          <li>High-performance aggregation/leaf switches for cloud-managed data centers and campus cores.</li>
        </ul>
      `,
    },
    {
      name: "Cisco SFS Blade Switches",
      bestSeller: false,
      image: `${basePath}MS450.png`,
      details: {
        Brand: "Cisco",
        Model: "SFS Blade",
        Type: "Blade Switch",
        Role: "Server blade chassis switching",
        Features: "High-density, backplane integration",
      },
      about: `
        <ul>
          <li>Blade switch modules designed for server chassis and blade environments.</li>
          <li>Integrates into vendor-specific blade server systems for consolidated switching.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 6500 Series (Legacy)",
      bestSeller: false,
      image: `${basePath}Catalyst_2960.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 6500",
        Type: "Legacy Modular",
        Role: "Historic core/aggregation",
        Features: "Modular slots, many legacy linecards",
      },
      about: `
        <ul>
          <li>Historic modular switch family previously used as campus/core switches.</li>
          <li>Many platforms are end-of-life but still present in legacy networks.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 2960 Series (Legacy)",
      bestSeller: false,
      image: `${basePath}Catalyst_3560.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 2960",
        Type: "Legacy Access",
        Ports: "24/48 x 1G",
        Features: "Layer 2 switching, basic management",
      },
      about: `
        <ul>
          <li>Widely-deployed legacy access switch family; many models now superseded by Catalyst 9200/9300.</li>
        </ul>
      `,
    },
    {
      name: "Cisco Catalyst 3560 Series (Legacy)",
      bestSeller: false,
      image: `${basePath}CBS350.png`,
      details: {
        Brand: "Cisco",
        Model: "Catalyst 3560",
        Type: "Legacy Access",
        Features: "Layer 3 Lite, PoE on some SKUs",
      },
      about: `
        <ul>
          <li>Legacy series used for small-to-medium campus access with some Layer 3 capabilities.</li>
        </ul>
      `,
    },
    {
      name: "Cisco CBS350 Series (Business-class)",
      bestSeller: false,
      image: `${basePath}CBS250.png`,
      details: {
        Brand: "Cisco",
        Model: "CBS350",
        Role: "Business managed",
        Features: "Smart-managed, PoE options",
      },
      about: `
        <ul>
          <li>Business-class managed switches offering a balance between SMB features and manageability.</li>
        </ul>
      `,
    },
    {
      name: "Cisco CBS250 / CBS350 SMB Series",
      bestSeller: false,
      image: `${basePath}CBS250.png`,
      details: {
        Brand: "Cisco",
        Model: "CBS250",
        Role: "SMB smart-managed",
        Features: "Web-based management, PoE options",
      },
      about: `
        <ul>
          <li>Smart-managed switches suitable for smaller businesses that need simple management and PoE.</li>
        </ul>
      `,
    },
  ],
};
